<div class="hidden-seats">
    <p class="info-hidden" *ngIf="!fromCreate">Gestiona los grupos de asientos bloqueados. Crea un grupo, dale un nombre y luego asigna los asientos del mapa que quieres bloquear.</p>
    <p class="info-hidden" *ngIf="fromCreate">*Termina de editar los cambios antes de guardar el evento</p>
    <!-- <div class="title-hidden-seats w-100">
        <div class="d-flex justify-content-between" *ngIf="idSpace">
            <p>Capacidad total:</p>
            <p>{{capacity}}</p>
        </div>
        <div class="d-flex justify-content-between">
            <p>Número de asientos ocultos:</p>
            <p><strong>{{countHiddenSeats}}</strong></p>
        </div>
    </div> -->
    <div class="drag-level-list">
        <div class="card-level" *ngFor="let type of hiddenTypes; let i = index"
             [class.card-level--selecting]="hiddenSeats == i">

            <!-- Cabecera: nombre, asientos y color -->
            <div class="d-flex w-100" style="gap: 20px;">
                <div class="d-flex justify-content-between align-items-center w-100">
                    <div class="info-level">
                        <p><strong>{{type.name}}</strong></p>
                        <p>{{type.id_seats?.length || 0}} asientos bloqueados</p>
                    </div>
                    <div class="color-level"
                        [style.background-color]="type.color ? type.color : defaultColors[type.orderBuy-1]">
                    </div>
                </div>
            </div>

            <mat-divider></mat-divider>

            <!-- ESTADO: seleccionando asientos en el mapa -->
            <ng-container *ngIf="hiddenSeats == i">
                <p class="selecting-hint">
                    <i class="fa-light fa-circle-info"></i>
                    Haz clic en los asientos del mapa para añadirlos o quitarlos de este grupo
                </p>
                <div class="d-flex justify-content-between icon-edit-level">
                    <div class="d-flex align-items-center item-edit save-styles"
                         (click)="assignSeats(true)">
                        <i class="fa-light fa-floppy-disk"></i>
                        <p>Guardar cambios</p>
                    </div>
                    <div class="d-flex align-items-center item-delete save-styles"
                         (click)="assignSeats(false)">
                        <i class="fa-light fa-ban"></i>
                        <p>Cancelar</p>
                    </div>
                </div>
            </ng-container>

            <!-- ESTADO: editando nombre y color -->
            <ng-container *ngIf="hiddenEdit == i && hiddenSeats != i">
                <div class="edit-level-forms">
                    <div class="bloque-form-input container-form d-flex align-items-center">
                        <input class="w-100" type="text" placeholder="Nombre del grupo" [(ngModel)]="type.name">
                    </div>
                    <div class="bloque-form-input container-form d-flex align-items-center">
                        <input class="w-100" type="text" placeholder="#Hex color" [(ngModel)]="type.color">
                        <div class="block-color">
                            <input type="color" [(ngModel)]="type.color">
                        </div>
                    </div>
                    <div class="bloque-form-input container-form d-flex align-items-center">
                        <input class="w-100" type="text" placeholder="Código de desbloqueo" [(ngModel)]="type.code" maxlength="100">
                    </div>
                </div>
                <div class="d-flex justify-content-between icon-edit-level">
                    <div class="d-flex align-items-center item-edit save-styles"
                         (click)="saveEditForm()">
                        <i class="fa-light fa-floppy-disk"></i>
                        <p>Guardar</p>
                    </div>
                    <div class="d-flex align-items-center item-delete save-styles"
                         (click)="cancelEditForm()">
                        <i class="fa-light fa-ban"></i>
                        <p>Cancelar</p>
                    </div>
                </div>
            </ng-container>

            <!-- ESTADO: vista normal (sin editar ni seleccionar) -->
            <ng-container *ngIf="hiddenSeats != i && hiddenEdit != i">
                <div class="actions-normal-grid">
                    <div class="d-flex align-items-center item-edit action-primary"
                         [class.disabled-clicks]="!enabledClickBtns"
                         (click)="typeAssignActive(type, i)">
                        <i class="fa-light fa-chair"></i>
                        <p>Asignar asientos</p>
                    </div>
                    <div class="actions-secondary">
                        <div class="d-flex align-items-center item-edit icon-only"
                             [class.disabled-clicks]="!enabledClickBtns"
                             title="Editar"
                             (click)="editItem(i, type)">
                            <i class="fa-light fa-pen"></i>
                        </div>
                        <div class="d-flex align-items-center item-delete action-delete"
                             [class.disabled-clicks]="!enabledClickBtns"
                             (click)="deleteItem(i)">
                            <i class="fa-light fa-trash-can"></i>
                            <p>Eliminar</p>
                        </div>
                    </div>
                </div>
            </ng-container>

        </div>
    </div>
</div>

<div *ngIf="!showNewForm" class="section-option mt-2" (click)="openNewForm()">
    <p class="m-0">Crear nuevo grupo de bloqueo</p>
    <i class="fa-light fa-layer-plus invisible-icon"></i>
    <i class="fa-light fa-plus add-icon"></i>
</div>

<div *ngIf="showNewForm" class="card-level mt-2">
    <div class="new-type-form">
        <p class="form-title">Nuevo grupo de bloqueo</p>
        <div class="edit-level-forms">
            <div class="bloque-form-input container-form d-flex align-items-center">
                <input class="w-100" type="text" placeholder="Nombre (ej: VIP, Prensa, Staff)" [(ngModel)]="newHiddenName" (click)="$event.stopPropagation()" />
            </div>
            <div class="bloque-form-input container-form d-flex align-items-center">
                <input class="w-100" type="text" placeholder="#Hex" [(ngModel)]="newHiddenColor" (click)="$event.stopPropagation()" />
                <div class="block-color">
                    <input type="color" [(ngModel)]="newHiddenColor" (click)="$event.stopPropagation()" />
                </div>
            </div>
            <div class="bloque-form-input container-form d-flex align-items-center">
                <input class="w-100" type="text" placeholder="Código de desbloqueo" [(ngModel)]="newHiddenCode" maxlength="100" (click)="$event.stopPropagation()" />
                <div class="block-color" title="Generar código aleatorio" (click)="generateCode(); $event.stopPropagation()">
                    <i class="fa-light fa-rotate-right" style="cursor:pointer;"></i>
                </div>
            </div>
        </div>
    </div>
    <mat-divider></mat-divider>
    <div class="d-flex justify-content-between icon-edit-level">
        <div class="d-flex align-items-center item-edit save-styles" (click)="confirmNewHidden()">
            <i class="fa-light fa-floppy-disk"></i>
            <p>Crear y asignar asientos</p>
        </div>
        <div class="d-flex align-items-center item-delete" (click)="cancelNewForm()">
            <i class="fa-light fa-ban"></i>
            <p>Cancelar</p>
        </div>
    </div>
</div>